import React from "react";
import SearchableMultiSelect from "src/components/custom/SearchableMultiSelect";
import { ItiFilterSuggestionSelect } from "src/components/mcc/ITIFilterSelect";

const inputClass =
  "w-full px-3 py-2 bg-white border border-gray-300 rounded-md text-sm text-gray-800 placeholder:text-gray-400 focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary transition-colors";

const readOnlyInputClass =
  "w-full px-3 py-2 bg-gray-100 border border-gray-200 rounded-md text-sm text-gray-600 cursor-not-allowed select-none";

export default function ItiFormFields({ form, setForm, tradenameOptions }) {
  const isEdit = Boolean(form?.id);
  return (
    <div className="space-y-4">
      <div>
        {isEdit ? (
          <>
            <label className="text-xs font-semibold text-primary mb-1.5 block">
              District
            </label>
            <input
              type="text"
              className={inputClass}
              placeholder="Enter district"
              value={form.district}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  district: e.target.value,
                }))
              }
            />
          </>
        ) : (
          <ItiFilterSuggestionSelect
            label="District"
            field="district"
            value={form.district}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                district: v,
                itiname: "",
              }))
            }
            placeholder="Select or search district…"
            allLabel="Select district"
          />
        )}
      </div>
      <div>
        {isEdit ? (
          <>
            <label className="text-xs font-semibold text-primary mb-1.5 block">
              ITI name
            </label>
            <input
              type="text"
              className={inputClass}
              placeholder="Enter ITI name"
              value={form.itiname}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  itiname: e.target.value,
                }))
              }
            />
          </>
        ) : (
          <ItiFilterSuggestionSelect
            label="ITI name"
            field="iti"
            formValueMode="label"
            value={form.itiname}
            onChange={(v) =>
              setForm((p) => ({
                ...p,
                itiname: v,
              }))
            }
            placeholder={
              form.district?.trim()
                ? "Select or search ITI…"
                : "Select district first"
            }
            allLabel="Select ITI"
            disabled={!form.district?.trim()}
            districtParam={form.district}
          />
        )}
      </div>
      {isEdit && (
        <>
          <div>
            <label className="text-xs font-semibold text-primary mb-1.5 block">
              Username
            </label>
            <input
              type="text"
              className={readOnlyInputClass}
              value={form.username ?? ""}
              readOnly
              disabled
              tabIndex={-1}
              aria-readonly="true"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-primary mb-1.5 block">
              Password
            </label>
            <input
              type="text"
              className={inputClass}
              placeholder="Enter password"
              value={form.password ?? ""}
              onChange={(e) =>
                setForm((p) => ({
                  ...p,
                  password: e.target.value,
                }))
              }
            />
          </div>
        </>
      )}
      <SearchableMultiSelect
        label="Trade"
        placeholder="Select Trade(s)"
        options={tradenameOptions}
        value={form.tradename}
        onChange={(v) => setForm((p) => ({ ...p, tradename: v }))}
      />
    </div>
  );
}
